
import SearchParsingError from "../errors/SearchParsingError";
import RequestToken from "./RequestToken";

class ValueToken extends RequestToken {
    constructor(tokenValue) {
        super("valueToken");

        this._tokenParams = {
            tokenValue: tokenValue
        };
    }

    /* override */
    toString() {
        return `ValueToken (${this._tokenParams.tokenValue})`;
    }

    /* override */
    toSearchRequest(childRequests) {
        if (childRequests != null) {
            if ((childRequests[0] != null) || (childRequests[1] != null)) {
                throw new SearchParsingError("Invalid Search Request: Value Cannot Have Children");
            }
        }

        return {
            "operation": "value",
            "value": this._tokenParams.tokenValue
        };
    }
}

export default ValueToken;



//////////////////
// WEBPACK FOOTER
// ./src/models/parser-tokens/ValueToken.js
// module id = MYNj
// module chunks = 1